import { connect } from 'react-redux'

import {
  doSelectReply,
  doToggleCollapedStateForCategories,
  doFetchCannedReplyCategories,
  doFetchCannedReplies,
} from 'ducks/cannedReplies/operations'
import { doHideModal } from 'actions/modals'

import {
  selectLastRequestedSearchTerm,
  selectIsLoadingCannedReplyCategories,
  selectIsLoadingCannedReplyTemplates,
  selectHasLoadedReplyCategories,
  selectFlatCannedReplyCategoriesWithTemplates,
  selectHasLoadedTemplates,
} from 'ducks/cannedReplies/selectors'
import { selectModalLeft } from 'selectors/modals_base'

import View from './view'

const select = state => ({
  items: selectFlatCannedReplyCategoriesWithTemplates(state),
  isLoadingCategories: selectIsLoadingCannedReplyCategories(state),
  isLoadingTemplates: selectIsLoadingCannedReplyTemplates(state),
  hasLoadedTemplates: selectHasLoadedTemplates(state),
  hasLoadedCategories: selectHasLoadedReplyCategories(state),
  modalLeft: selectModalLeft(state),
  searchTerm: selectLastRequestedSearchTerm(state),
})

const perform = {
  toggleCollapedStateForCategories: doToggleCollapedStateForCategories,
  hideModal: doHideModal,
  selectReply: doSelectReply,
  fetchCannedReplyCategories: doFetchCannedReplyCategories,
  fetchCannedReplies: doFetchCannedReplies,
}

export default connect(select, perform)(View)
